<template>
  <v-app id="sanne">
    <v-main>
      <v-container fluid>
      <v-row>
          <v-col cols="2">
            <v-select v-model="bedrCodesSelected" :items="bedrCodes" item-value="bedrCode"  item-text="bedrCode" label="Companies" multiple></v-select>
          </v-col>
      </v-row>

      <v-row>    
          <v-col cols="1">
             <v-btn class="primary ma-0" small :disabled="results" @click="ovrz">Create excel</v-btn>
          </v-col> 
      </v-row>

    </v-container>
    </v-main>
    <navBar title="Ares - Excel Exports" :home="true" type="excel" />
    <showProgress ref="showProgress"></showProgress>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import showProgress from "@/components/showProgress.vue";
 export default {
  components: {
    navBar,
    showProgress
  },
  data() {
    return {
      bedrCodesSelected: [],
      bedrCodes: [],
      results: false,
      param: {}
    }
  },
  created() {
    var deze = this;
      this.$axios
      .post("ares/json/ares/task/excel/tmp/getSanneParam.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getSanneParam"
        },
        getSanneParam: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.param = res.data.getSanneParam;
           res.data.getSanneParam.bedrKeuzes.forEach(function(bedr) {
             deze.bedrCodes.push(bedr.bedrCode);
             if (bedr.bedrSelected === true) {
                deze.bedrCodesSelected.push(bedr.bedrCode);
             }
           });
        }
      });

  },
  methods: {
     ovrz() {
      this.results = true;
      this.$refs.showProgress.open();
      this.$axios
        .post("ares/json/ares/task/excel/tmp/sanne.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "sanne"
          },
          sanne: {
            bedr_codes: this.bedrCodesSelected
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.sanne;
            this.$refs.showProgress.close();
            this.results = false;
            window.open(this.items.filename,'_blank');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  }
};

</script> 
